var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThaw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.3423 0 0 4.3423 473.9237 1011.8758)",
    id: 527695
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -165.055 133.48)",
    id: "_2-8_C_Fridge"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-154.405, -452.94)",
    d: "M 111.87 531.56 v -21.03 l 15.53 -19.83 c 20.07 -25.57 36.56 -46.84 36.56 -69.06 c 0 -12.43 -6.93 -21.27 -19.83 -21.27 c -9.8 0 -17.68 4.3 -23.42 7.89 l -5.5 -24.38 c 7.17 -4.54 20.55 -9.56 34.65 -9.56 c 33.93 0 44.93 22.7 44.93 44.93 c 0 29.15 -18.16 52.57 -36.08 73.36 l -9.32 10.99 v 0.48 h 47.55 v 27.48 H 111.87 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -80.575 146.14)",
    id: "_2-8_C_Fridge"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-238.885, -465.6)",
    d: "M 262.66 454.37 v 22.46 h -47.55 v -22.46 h 47.55 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.145 134.435)",
    id: "_2-8_C_Fridge"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-320.605, -453.895)",
    d: "M 274.6 491.17 c 0 -19.36 10.75 -33.22 23.42 -41.34 v -0.48 c -13.14 -8.6 -19.12 -21.99 -19.12 -34.17 c 0 -25.33 20.07 -40.86 43.97 -40.86 c 22.22 0 40.15 15.06 40.15 38.24 c 0 10.28 -4.06 24.14 -20.31 34.41 v 0.48 c 14.34 7.89 23.9 22.22 23.9 40.62 c 0 28.68 -21.03 45.4 -46.6 45.4 s -45.4 -16.97 -45.4 -42.3 Z m 61.65 -1.91 c 0 -14.58 -9.08 -24.14 -17.92 -28.68 c -7.89 5.5 -13.38 15.05 -13.38 27 c 0 13.38 5.5 24.85 16.25 24.85 c 9.8 0 15.06 -10.04 15.06 -23.18 Z m -27.96 -75.04 c 0 10.99 6.21 18.64 15.29 23.42 c 6.69 -3.58 10.75 -13.14 10.75 -22.22 c 0 -10.51 -3.58 -20.07 -12.67 -20.07 s -13.38 9.32 -13.38 18.88 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 87.175 78.035)",
    id: "_2-8_C_Fridge"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-406.635, -397.495)",
    d: "M 435.43 397.02 c 0 19.12 -16.01 29.39 -29.15 29.39 c -16.49 0 -28.44 -11.95 -28.44 -27.96 c 0 -16.97 14.34 -29.87 28.91 -29.87 c 17.92 0 28.68 13.14 28.68 28.44 Z m -43.49 1.2 c 0 8.84 6.93 16.01 14.82 16.01 s 14.82 -6.69 14.82 -16.25 c 0 -8.6 -4.78 -17.21 -14.82 -17.21 c -7.89 0 -14.82 8.12 -14.82 17.45 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 170.095 131.56)",
    id: "_2-8_C_Fridge"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-489.555, -451.02)",
    d: "M 531.25 529.17 c -4.54 2.15 -13.38 3.82 -24.37 3.82 c -41.1 0 -60.7 -33.93 -60.7 -79.58 c 0 -60.7 33.69 -84.36 65 -84.36 c 10.99 0 18.64 2.15 21.75 4.3 l -5.26 26.29 c -3.58 -1.67 -7.65 -3.11 -14.58 -3.11 c -17.68 0 -33.69 15.29 -33.69 55.2 s 14.58 53.53 33.69 53.53 c 5.26 0 11.23 -1.2 15.06 -2.39 l 3.11 26.29 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.185 -117.885)",
    id: "_2-8_C_Fridge"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-325.645, -201.575)",
    d: "M 334.55 285.05 v 31.75 h -17.72 v -31.45 c -6.73 6.73 -13.44 13.44 -20.08 20.08 c -4.34 -4.34 -8.49 -8.49 -12.86 -12.86 c 0.18 -0.11 0.53 -0.25 0.77 -0.49 c 10.52 -10.51 21.04 -21.02 31.54 -31.55 c 0.31 -0.31 0.57 -0.84 0.57 -1.27 c 0.03 -13.72 0.02 -27.44 0.02 -41.15 v -0.8 c -0.36 0.19 -0.61 0.31 -0.86 0.45 c -11.72 7.03 -23.44 14.07 -35.17 21.09 c -0.58 0.35 -0.88 0.76 -1.05 1.41 c -3.61 14.35 -7.24 28.69 -10.87 43.04 c -0.06 0.25 -0.15 0.5 -0.27 0.88 c -5.71 -1.44 -11.4 -2.89 -17.19 -4.35 c 2.31 -9.15 4.61 -18.21 6.96 -27.51 c -9.11 5.47 -18.01 10.81 -27 16.2 c -3.05 -5.09 -6.08 -10.14 -9.14 -15.23 c 9.14 -5.49 18.22 -10.93 27.48 -16.49 c -9.5 -2.41 -18.79 -4.76 -28.2 -7.14 c 1.45 -5.74 2.89 -11.44 4.36 -17.22 c 2.46 0.62 4.86 1.22 7.25 1.82 c 12.46 3.16 24.91 6.32 37.37 9.45 c 0.4 0.1 0.95 0.03 1.31 -0.18 c 11.99 -7.16 23.96 -14.36 35.93 -21.54 c 0.18 -0.11 0.35 -0.22 0.64 -0.4 c -0.35 -0.22 -0.63 -0.41 -0.92 -0.58 c -11.82 -7.09 -23.65 -14.18 -35.46 -21.29 c -0.55 -0.33 -1.03 -0.4 -1.65 -0.25 c -14.54 3.7 -29.08 7.38 -43.62 11.07 c -0.25 0.06 -0.51 0.1 -0.85 0.16 c -1.45 -5.73 -2.89 -11.43 -4.35 -17.18 c 9.39 -2.38 18.69 -4.73 28.2 -7.14 c -9.25 -5.55 -18.32 -11 -27.48 -16.49 c 3.05 -5.09 6.08 -10.13 9.14 -15.23 c 8.97 5.38 17.88 10.72 27 16.2 c -2.35 -9.29 -4.64 -18.35 -6.96 -27.5 c 5.78 -1.46 11.47 -2.91 17.22 -4.36 c 0.99 3.91 1.96 7.7 2.92 11.5 c 2.74 10.83 5.48 21.66 8.2 32.49 c 0.16 0.62 0.46 1.01 1.01 1.34 c 11.71 7 23.4 14.02 35.1 21.04 c 0.27 0.16 0.55 0.31 0.95 0.53 v -1.06 c 0 -13.57 0 -27.14 0.01 -40.71 c 0 -0.64 -0.17 -1.09 -0.63 -1.55 c -10.51 -10.48 -21 -20.98 -31.5 -31.47 c -0.25 -0.25 -0.55 -0.44 -0.75 -0.6 c 4.29 -4.29 8.44 -8.44 12.63 -12.63 c 6.65 6.65 13.35 13.35 20.21 20.21 v -31.74 h 17.73 v 31.64 c 6.83 -6.83 13.54 -13.54 20.19 -20.19 c 4.28 4.28 8.43 8.43 12.73 12.73 c -0.22 0.16 -0.54 0.33 -0.79 0.58 c -10.5 10.49 -21 20.98 -31.47 31.49 c -0.32 0.32 -0.61 0.84 -0.61 1.26 c -0.03 13.81 -0.03 27.61 -0.03 41.42 c 0 0.15 0.01 0.29 0.02 0.56 c 0.27 -0.14 0.5 -0.23 0.71 -0.36 c 11.82 -7.09 23.65 -14.18 35.46 -21.3 c 0.37 -0.22 0.7 -0.71 0.81 -1.14 c 3.65 -14.34 7.28 -28.68 10.91 -43.02 c 0.08 -0.31 0.17 -0.62 0.29 -1.02 c 5.71 1.45 11.39 2.88 17.2 4.35 c -2.31 9.12 -4.6 18.18 -6.96 27.51 c 9.12 -5.47 18.03 -10.81 27 -16.2 c 3.06 5.09 6.07 10.12 9.14 15.23 c -9.13 5.48 -18.23 10.94 -27.48 16.5 c 9.51 2.41 18.81 4.76 28.2 7.14 c -1.46 5.77 -2.9 11.47 -4.36 17.23 c -3.69 -0.94 -7.28 -1.85 -10.88 -2.76 c -11.23 -2.84 -22.46 -5.69 -33.69 -8.51 c -0.42 -0.11 -1.01 -0.03 -1.39 0.19 c -11.96 7.15 -23.91 14.32 -35.86 21.49 c -0.2 0.12 -0.38 0.25 -0.66 0.43 c 0.33 0.22 0.59 0.4 0.85 0.56 c 11.85 7.11 23.7 14.21 35.53 21.34 c 0.56 0.34 1.05 0.37 1.65 0.21 c 14.54 -3.7 29.08 -7.38 43.62 -11.06 c 0.23 -0.06 0.46 -0.09 0.81 -0.16 c 1.44 5.7 2.89 11.4 4.35 17.19 c -9.37 2.37 -18.67 4.73 -28.2 7.14 c 9.24 5.55 18.33 11.01 27.48 16.49 c -3.05 5.08 -6.07 10.11 -9.14 15.23 c -8.96 -5.38 -17.88 -10.72 -27 -16.2 c 2.35 9.3 4.65 18.37 6.96 27.5 c -5.78 1.46 -11.46 2.9 -17.22 4.36 c -0.64 -2.49 -1.25 -4.91 -1.87 -7.33 c -3.09 -12.23 -6.18 -24.46 -9.3 -36.68 c -0.11 -0.43 -0.42 -0.93 -0.79 -1.16 c -11.86 -7.15 -23.73 -14.27 -35.61 -21.39 c -0.15 -0.09 -0.3 -0.17 -0.56 -0.31 c -0.02 0.35 -0.05 0.63 -0.05 0.9 c 0 13.66 0 27.32 0.02 40.98 c 0 0.46 0.26 1.03 0.58 1.36 c 10.47 10.51 20.97 21.01 31.47 31.5 c 0.25 0.25 0.55 0.45 0.74 0.6 c -4.25 4.25 -8.4 8.4 -12.63 12.63 c -6.59 -6.61 -13.3 -13.33 -20.17 -20.21 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThaw);
export default __webpack_public_path__ + "static/media/thaw.66e8a37531fb0e8f330f0aff50ab1e2e.svg";
export { ForwardRef as ReactComponent };